import { Controller } from "stimulus";

import { submitForm } from "init/ajax";
import { loadModalUrl } from "../modal/utils"

export default class extends Controller {
  modalLink(event) {
    event.preventDefault();

    loadModalUrl(event.target.href);
  }

  async submit(event) {
    event.preventDefault();

    const form = event.target;
    // Consider everything valid if browser validations aren't supported
    if (!form.reportValidity || form.reportValidity()) {
      const responseHTML = await submitForm(form);

      if (responseHTML && responseHTML.querySelector(".modal")) {
        document.body.appendChild(responseHTML);
      }

      if (responseHTML && responseHTML.querySelector(".account-sign-in-block")) {
        const errorsBlock = document.querySelector(".account-sign-in-block-input-errors")
        const errorsFromResponse = responseHTML.querySelector(".account-sign-in-block-input-errors")
        if (errorsBlock) {
          document
            .querySelector(".account-sign-in-block-input-errors")
            .replaceWith(errorsFromResponse)
        } else {
          const formNode = document.querySelector(".account-sign-in-form")
          const formChildNode = formNode.querySelector(".account_sign_in_block__bottom")
          formNode.insertBefore(errorsFromResponse, formChildNode)
        }
      }
    }
  }
}
